import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import classes from './ArrowButton.module.scss';

const ArrowButton = ({
  isNext,
  className,
  iconClassName,
  style,
  onClick,
  type,
}) => {
  const iconPerType = {
    ArrowButtonA: (
      <FontIcon
        icon={isNext ? 'far fa-angle-right' : 'far fa-angle-left'}
        className={iconClassName}
      />),
    ArrowButtonB: (
      <div className={classes.arrowContainer}>
        <FontIcon
          icon={isNext ? 'far fa-chevron-right' : 'far fa-chevron-left'}
          className={iconClassName}
        />
      </div>),
  };

  return (
    <button
      aria-label={isNext ? 'Next' : 'Previous'}
      className={className}
      style={style}
      onClick={onClick}
      type='button'
    >
      {iconPerType[type]}
    </button>
  );
};

ArrowButton.propTypes = {
  isNext: PropTypes.bool,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  type: PropTypes.string,
};

export default ArrowButton;
